import { render, staticRenderFns } from "./FcnContactForm.vue?vue&type=template&id=bbc5af2a&"
import script from "./FcnContactForm.vue?vue&type=script&lang=js&"
export * from "./FcnContactForm.vue?vue&type=script&lang=js&"
import style0 from "./FcnContactForm.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports